module.exports = __webpack_public_path__ + "img/Banner_log-in.8ec81215.webp";